import StateTitle from "@/component/StateTitle";
import StateItem from "@/component/StateItem";
import {useEffect, useState} from "react";
import {stateApi} from "@/utils/stateApi";
import {FeesRecommended, Heartbeat, stateItem} from "@/utils/stateApiType";
import {BITCOIN_STATE_NAME, FRACTAL_STATE_NAME} from "@/utils/constants";
import serverData from '@/data/config.json'
import {Skeleton} from "antd";
import {hasConsecutiveZeros, StateText} from "@/utils/stateChange";
import Link from "antd/es/typography/Link";
import NetworkFeeCom from "@/component/NetworkFeeCom";

export default function QueryState() {
    const [feesRecommendedFractal, setFeesRecommendedFractal] = useState<FeesRecommended | null>(null)
    const [feesRecommendedBtc, setFeesRecommendedBtc] = useState<FeesRecommended>()
    const [bitcoinStateList, setBitcoinStateList] = useState<stateItem[] | null>(null)
    const [fractalStateList, setFractalStateList] = useState<stateItem[] | null>(null)
    const [bitcoinState, setBitcoinState] = useState<number>(1)
    const [fractalState, setFractalState] = useState<number>(1)


    const getStatus = async () => {

        try {

            stateApi.getFeesRecommendedFractal().then(res => {
                setFeesRecommendedFractal(res)
            }).catch(e => {
            })

            stateApi.getFeesRecommendedBtc().then(res => {
                setFeesRecommendedBtc(res)
            }).catch(e => {
            })
            const fractalNameS = []
            serverData.fractal.forEach((fractal) => {
                fractalNameS.push(fractal.name)
            })

            const fractalStatusPageDetail = await stateApi.getStatusPage(FRACTAL_STATE_NAME)

            const fractalStatusPageHeartbeatDetail = await stateApi.getStatusPageHeartbeat(FRACTAL_STATE_NAME)
            const bitcoinStatusPageDetail = await stateApi.getStatusPage(BITCOIN_STATE_NAME)
            const bitcoinStatusPageHeartbeatDetail = await stateApi.getStatusPageHeartbeat(BITCOIN_STATE_NAME)

            const fractalMonitorList: any = serverData.fractal.filter(item =>
                fractalStatusPageDetail.publicGroupList[0].monitorList.some(fractalItem => {
                    if (fractalItem.name === item.name) {
                        const data: any = item
                        data.heartbeatList = fractalStatusPageHeartbeatDetail.heartbeatList[fractalItem.id]
                        return data
                    }
                    return false
                })
            )

            const bitcoinMonitorList: any = serverData.bitcoin.filter(item =>
                bitcoinStatusPageDetail.publicGroupList[0].monitorList.some(fractalItem => {
                    if (fractalItem.name === item.name) {
                        const data: any = item
                        data.heartbeatList = bitcoinStatusPageHeartbeatDetail.heartbeatList[fractalItem.id]
                        return data
                    }
                    return false
                })
            )

            fractalMonitorList.forEach((item: any) => {
                item.heartbeatList = [...HeartbeatListChange(item.heartbeatList)]
            })
            bitcoinMonitorList.forEach((item: any) => {
                item.heartbeatList = [...HeartbeatListChange(item.heartbeatList)]
            })

            let bitcoinNum= 0
            setBitcoinState(1)
            for (const item of bitcoinMonitorList) {
                const stateNum = hasConsecutiveZeros(item.heartbeatList, 1)
                if (stateNum === 2) {
                    setBitcoinState(stateNum);
                }
                if (stateNum === 0) {
                    setBitcoinState(2);
                    bitcoinNum++
                }
            }
            if(bitcoinNum===bitcoinMonitorList.length){
                setBitcoinState(0);
            }

            let fractalStateNum= 0
            setFractalState(1)
            for (const item of fractalMonitorList) {
                const stateNum = hasConsecutiveZeros(item.heartbeatList, 1)
                if (stateNum === 2) {
                    setFractalState(stateNum);
                }
                if (stateNum === 0) {
                    setFractalState(2);
                    fractalStateNum++
                }
            }
            if(fractalStateNum===fractalMonitorList.length){
                setFractalState(0);
            }


            sortByLastStatus(bitcoinMonitorList);
            sortByLastStatus(fractalMonitorList);


            setFractalStateList(fractalMonitorList.filter((item: any) => item.heartbeatList))

            setBitcoinStateList(bitcoinMonitorList.filter((item: any) => item.heartbeatList))

        } catch (e) {
        }


    }

    useEffect(() => {
        (async () => {
            await getStatus()
        })()


    }, [])

    function sortByLastStatus(arr: any[]): any[] {
        return arr.sort((a, b) => {
            const lastA = a.heartbeatList[a.heartbeatList.length - 1].status;
            const lastB = b.heartbeatList[b.heartbeatList.length - 1].status;

            if (lastA === 0 && lastB !== 0) {
                return -1;
            } else if (lastA !== 0 && lastB === 0) {
                return 1;
            } else {
                return 0;
            }
        });
    }


    const HeartbeatListChange = (heartbeatListVal: Heartbeat[]) => {
        let HeartbeatList: Heartbeat[] = [];

        const processHeartbeatList = (startIdx: number, step: number, isWhole?: boolean) => {
            let isStep = isWhole
            for (let i = startIdx; i < heartbeatListVal.length; i += (isStep ? 17 : step)) {
                let hasStatusError = false;
                let isPadding = false
                for (let j = i; j < i + step && j < heartbeatListVal.length; j++) {
                    if (heartbeatListVal[j].status === 2 || heartbeatListVal[j].status === 3) {
                        isPadding = true;
                        break;
                    }
                }
                for (let j = i; j < i + step && j < heartbeatListVal.length; j++) {
                    if (!heartbeatListVal[j].status) {
                        hasStatusError = true;
                        break;
                    }
                }
                if (isPadding) {
                    heartbeatListVal[i].status = 2;
                }
                if (hasStatusError) {
                    heartbeatListVal[i].status = 0;
                }
                HeartbeatList.push(heartbeatListVal[i]);
                if (i && isStep) {
                    isStep = false
                }
            }
        };

        const length = heartbeatListVal.length;

        if (length <= 50) {
            HeartbeatList = heartbeatListVal;
        } else if (length > 50 && length < 100) {
            processHeartbeatList(length - 50, 1);
        } else if (length === 100) {
            processHeartbeatList(0, 2);
        } else if (length > 100 && length < 150) {
            processHeartbeatList(length - 100, 2);
        } else if (length === 150) {
            processHeartbeatList(0, 3);
        } else if (length > 150 && length < 200) {
            processHeartbeatList(length - 150, 3)
        } else if (length === 200) {
            processHeartbeatList(0, 4);
        } else if (length > 200 && length < 250) {
            processHeartbeatList(length - 200, 4);
        } else if (length === 250) {
            processHeartbeatList(0, 5);
        } else if (length > 250 && length < 300) {
            processHeartbeatList(length - 250, 5);
        } else if (length === 300) {
            processHeartbeatList(0, 6);
        } else if (length > 300 && length < 350) {
            processHeartbeatList(length - 300, 6);
        } else if (length === 350) {
            processHeartbeatList(0, 7);
        } else if (length > 350 && length < 360) {
            processHeartbeatList(length - 350, 7);
        } else if (length === 360) {
            processHeartbeatList(0, 6);
        }
        return HeartbeatList;
    };


    return (<div className={`main-container`}>
        <Link href={`https://unisat.io/`} target={`_blank`} className="flex justify-center">
            <img src="/img/app-logo.png" alt="App Logo"/>
        </Link>
        <StateTitle getStatus={getStatus} state={{bitcoinState,fractalState}}/>
        <div className={`flex justify-center`}>
            <div className={` flex flex-wrap  mt-[24px] gap-[26px] flex-center-1300 w-full`}>
                {bitcoinStateList ? <div className={`flex flex-col gap-[24px]`}>
                    <div className={`flex-row-v-center gap-3`}>
                        <img src="/img/btc-icon.svg" alt=""/>
                        <div className={`text-white text-[28px] font-semibold`}>Bitcoin</div>
                        <span style={{border: `1px solid ${bitcoinState===0 ? '#F55454' :bitcoinState===2?'#F4B62C': '#3AC79D'}`}}
                              className={`flex-row-v-center text-white ${bitcoinState === 0 ? 'bg-[#F5545430]' :bitcoinState===2?'bg-[#F4B62C30]': 'bg-[#3AC79D30]'} text-sm rounded-lg px-3 py-1.5`}>{StateText(bitcoinState)}</span>
                    </div>

                    {bitcoinStateList.map(item => (
                        <StateItem key={item.title} statusList={item.heartbeatList} name={item.title}
                                   colorStyle={{
                                       borderColor: item.borderColor,
                                       background: item.background
                                   }}
                                   icon={<div dangerouslySetInnerHTML={{__html: item.icon}}></div>}/>
                    ))}
                </div> : <Skeleton active/>}
                {(bitcoinStateList && fractalStateList) && <div className={`state-dashed-line `}></div>}
                {fractalStateList ? <div className={`flex flex-col gap-[24px]`}>
                    <div className={`flex-row-v-center gap-3`}>
                        <img src="/img/fractal-icon.svg" width={38} height={38} className={`border-[1px] border-[rgba(255,255,255,.5)] rounded-[50%]`} alt=""/>
                        <div className={`text-white text-[28px] font-semibold`}>Fractal</div>
                        <span style={{border: `1px solid ${fractalState===0 ? '#F55454' :fractalState===2?'#F4B62C': '#3AC79D'}`}}
                              className={`flex-row-v-center text-white ${fractalState===0 ? 'bg-[#F5545430]' :fractalState===2?'bg-[#F4B62C30]': 'bg-[#3AC79D30]'} text-sm rounded-lg px-3 py-1.5`}>{StateText(fractalState)}</span>
                    </div>
                    {fractalStateList.map(item => (
                        <StateItem key={item.title} statusList={item.heartbeatList} name={item.title}
                                   colorStyle={{
                                       borderColor: item.borderColor,
                                       background: item.background
                                   }}
                                   icon={<div dangerouslySetInnerHTML={{__html: item.icon}}></div>}/>
                    ))}
                </div> : <Skeleton active/>}

            </div>
        </div>

        <div className={`rounded-[24px] bg-[#1E1F24] w-full text-white mt-[32px] flex flex-block-600`}>
            {feesRecommendedBtc &&<div className={`flex-1`}>

                    <NetworkFeeCom icon={<img src="/img/btc.svg" alt=""/>} title={'Bitcoin Network Fee'} fee={{
                        low: feesRecommendedBtc?.hourFee,
                        medium: feesRecommendedBtc.halfHourFee,
                        high: feesRecommendedBtc.fastestFee,
                    }}/>
            </div>}
            {feesRecommendedFractal && <div className={`flex-1`}>

                    <NetworkFeeCom icon={<img src="/img/fractal-icon.svg" width={28} height={28} className={`border-[1px] border-[rgba(255,255,255,.5)] rounded-[50%]`} alt=""/>} title={'Fractal Network Fee'} fee={{
                        low: feesRecommendedFractal.hourFee,
                        medium: feesRecommendedFractal.halfHourFee,
                        high: feesRecommendedFractal.fastestFee,
                    }}/>
            </div>}
        </div>

    </div>)
}